import { hasFlag } from 'legacy/lut/components/widgets/public/partner360/reports/managerDashboard/helpers/hasFlag'

import { IWelcomeFlowPartner } from '../api'

import { TOP_BPS, TOP_OPH } from './groupByTops'

/**
 * Checks if the given partner is a TOP partner (has any TOP flag in BitClass).
 * TOP partners include those with TOP OPH flags (TopMarketOph, TopWwOph) or
 * TOP BPS flags (TopMarketBps, TopWwBps).
 */
export const isTopPartner = (welcomeflowPartner: IWelcomeFlowPartner): boolean => {
  return (
    TOP_OPH.some((flag) => hasFlag(flag, welcomeflowPartner.BitClass)) ||
    TOP_BPS.some((flag) => hasFlag(flag, welcomeflowPartner.BitClass))
  )
}
